import CryptoJS from 'crypto-js'

export function getAes(data) {
	let key = CryptoJS.enc.Utf8.parse("123qazxsw456edcv");
	let iv = CryptoJS.enc.Utf8.parse('1234567890123456');  
  
    let srcs = CryptoJS.enc.Utf8.parse(JSON.stringify(data));
    var encrypted = CryptoJS.AES.encrypt(srcs, key, {
        iv: iv, 
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.ZeroPadding
    });
    return CryptoJS.enc.Base64.stringify(encrypted.ciphertext);
}

export function FormatDate(str) {
  return "1" + str;
}
export function jsonreplace(item, oldkeys, newkeys) {
  var result;
  item.forEach(function (val) {
    result = val;
    for (var i = 0; i < oldkeys.length; i++) {
      result[newkeys[i]] = val[oldkeys[i]];
      result.scopedSlots = {title:'custom'}
    }
    if (val.children) {
      result.children = jsonreplace(val.children, oldkeys, newkeys);
      result.scopedSlots = {title:'custom'}
    }
  })
  return item
}

export function jsonreplace1(item, oldkeys, newkeys) {
  var result;
  item.forEach(function (val) {
    result = val;
    for (var i = 0; i < oldkeys.length; i++) {
      result[newkeys[i]] = val[oldkeys[i]];
      result.value = result.key
      if(result.disabled){
        var a = eval(result.disabled.toLowerCase())
        result.disabled = a
      }
      
    }
    if (val.children) {
      result.children = jsonreplace1(val.children, oldkeys, newkeys);
      result.value = result.key
      if(result.disabled){
        // var a = eval(result.disabled.toLowerCase())
        result.disabled = a
      }
    }
  })
  return item
}
export function setUserinfo(item) {
  if (setUserinfo)
    sessionStorage.setItem("$ywtwzuserinfo", JSON.stringify(item));
}
export function User() {
  if (sessionStorage.getItem("$ywtwzuserinfo"))
    return JSON.parse(sessionStorage.getItem("$ywtwzuserinfo"))
  else
    return "";
}

//转换时间格式
export function nowDate(data){
  if(data == undefined){
    data = ''
    var date = new Date()
  }else{
    var date = new Date(data)
  }
  
  var year = date.getFullYear()
  var mouth = date.getMonth()+1
  var day = date.getDate()
  if(mouth<10){
    mouth = '0' + mouth
  }
  if(day<10){
    day = '0' + day
  }
  var newdata = year + '-' + mouth + '-' + day
  return newdata
}
//自适应获取table的高度
/**
 * @param {String} wrap - wrap
 * @param {Array} top - 需要去除高度的元素id
 * @param {Number} num - 各个元素之见的margin和padding
 */
export function getTableHeight(wrap, top, num) {
  var wrap1 = document.getElementById(wrap).offsetHeight
  var a;
  for (var i in top) {
      var top1 = document.getElementById(top[i]).offsetHeight
      wrap1 = wrap1 - top1
  }
  return wrap1 - num
}
export function getTableHeight2(wrap, top, num) {
  var wrap1 = document.getElementsByClassName(wrap).offsetHeight
  var a;
  for (var i in top) {
      var top1 = document.getElementById(top[i]).offsetHeight
      wrap1 = wrap1 - top1
  }
  return wrap1 - num
}
//数字转换成大写的jine
export function menoyToUppercase(money) {
  var cnNums = new Array('零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖');	 //汉字的数字
  var cnIntRadice = new Array('', '拾', '佰', '仟'); //基本单位
  var cnIntUnits = new Array('', '万', '亿', '兆');  //对应整数部分扩展单位
  var cnDecUnits = new Array('角', '分', '毫', '厘'); //对应小数部分单位
  var cnInteger = '整';	//整数金额时后面跟的字符			
  var cnIntLast = '元';	//整数完以后的单位
  //最大处理的数字
  var maxNum = 999999999999999.9999;
  var integerNum;	 //金额整数部分
  var decimalNum;	 //金额小数部分
  //输出的中文金额字符串
  var chineseStr = '';
  var parts;		//分离金额后用的数组，预定义
  if (money == '') { return ''; }
  
  money = parseFloat(money);
  if (money >= maxNum) {
    //超出最大处理数字
    return '超出最大处理数字';
  }
  if (money == 0) {
    chineseStr = cnNums[0] + cnIntLast + cnInteger;
    return chineseStr;
  }
  
//四舍五入保留两位小数,转换为字符串
money = Math.round(money * 100).toString();
integerNum = money.substr(0,money.length-2);
decimalNum = money.substr(money.length-2);
  
  //获取整型部分转换
  if (parseInt(integerNum, 10) > 0) {
    var zeroCount = 0;
    var IntLen = integerNum.length;
    for (var i = 0; i < IntLen; i++) {
      var n = integerNum.substr(i, 1);
      var p = IntLen - i - 1;
      var q = p / 4;
      var m = p % 4;
      if (n == '0') {
        zeroCount++;
      } else {
        if (zeroCount > 0) {
          chineseStr += cnNums[0];
        }
        //归零
        zeroCount = 0;
        chineseStr += cnNums[parseInt(n)] + cnIntRadice[m];
      }
      if (m == 0 && zeroCount < 4) {
        chineseStr += cnIntUnits[q];
      }
    }
    chineseStr += cnIntLast;
  }
  //小数部分
  if (decimalNum != '') {
    var decLen = decimalNum.length; 
    for (var i = 0; i < decLen; i++) {
      var n = decimalNum.substr(i, 1);
      if (n != '0') {
        chineseStr += cnNums[Number(n)] + cnDecUnits[i];
      }
    }
  }
  if (chineseStr == '') {
    chineseStr += cnNums[0] + cnIntLast + cnInteger;
  } else if (decimalNum == '' || /^0*$/.test(decimalNum)) {
    chineseStr += cnInteger;
  }
  return chineseStr;
}

export function JsonrePlaceTree_child(item, oldkeys, newkeys) {
	var result;
	item.forEach(function (val) {
		result = val;
		for (var i = 0; i < oldkeys.length; i++) {
			result[newkeys[i]] = val[oldkeys[i]];
		}
		if (val.children) {
			if (val.children.length > 0) {
				result.children = JsonrePlaceTree_child(val.children, oldkeys, newkeys);
			} else {
				delete val.children;
				delete result.children;
			}
		} else {
			delete val.children;
			delete result.children;
		}
	})
	return item
}
export function JsonrePlaceTree_schildrenList(item, oldkeys, newkeys) {
	var result;
	item.forEach(function (val) {
		result = val;
		for (var i = 0; i < oldkeys.length; i++) {
			result[newkeys[i]] = val[oldkeys[i]];
		}
		if (val.schildrenList) {
			if (val.schildrenList.length > 0) {
				result.schildrenList = JsonrePlaceTree_schildrenList(val.schildrenList, oldkeys, newkeys);
			} else {
				delete val.schildrenList;
				delete result.schildrenList;
			}
		} else {
			delete val.schildrenList;
			delete result.schildrenList;
		}
	})
	return item
}
// 日期格式化
export function timeFormat(date) {
  if (!date || typeof(date) === "string") {
    this.error("参数异常，请检查...");
  }
  var y = date.getFullYear()+''; //年
  var m = ((date.getMonth() + 1)+'').padStart(2,'0'); //月
  var d = (date.getDate()+'').padStart(2,'0'); //日
  var h = (date.getHours()+ '').padStart(2,'0'); //日
  var mi = (date.getMinutes()+'').padStart(2,'0'); //日
  var s = (date.getSeconds()+'').padStart(2,'0'); //日

  return y + '-' + m + '-' + d;
}
// 日期格式化
export function monthFormat(date) {
  if (!date || typeof(date) === "string") {
    this.error("参数异常，请检查...");
  }
  var y = date.getFullYear()+''; //年
  var m = ((date.getMonth() + 1)+'').padStart(2,'0'); //月
  var d = (date.getDate()+'').padStart(2,'0'); //日
  var h = (date.getHours()+ '').padStart(2,'0'); //日
  var mi = (date.getMinutes()+'').padStart(2,'0'); //日
  var s = (date.getSeconds()+'').padStart(2,'0'); //日

  return y + '-' + m;
}
// 获取token
export function GetRequest(urlStr) {//两种方式，输入链接获取或当前链接获取
    if (typeof urlStr == "undefined") {
      var url = decodeURI(location.search); //获取url中"?"符后的字符串
  } else {
        var url = "?" + urlStr.split("?")[1];
    }
    var theRequest = new Object();
    if (url.indexOf("?") != -1) {
        var str = url.substring(1);//去掉问号，问号为第一个字符
        var strs = str.split("&");
        for (var i = 0; i < strs.length; i++) {
            theRequest[strs[i].split("=")[0]] = decodeURI(strs[i].split("=")[1]);
        }
    }
    return theRequest;
}

/**
 * 将file文件转化为base64 使用promise
 * @param file 该文件的file类型
 */
export function fileTransferBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader(); //异步读取
      reader.readAsDataURL(file);
      // 成功和失败返回对应的信息，reader.result一个base64，可以直接使用
      reader.onload = (e) => {
        resolve(e.target.result);
      };
      // 失败返回失败的信息
      reader.onerror = (error) => {
        console.warn('file文件转化为base64s失败：', error);
        reject(error);
      };
    });
}
